module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "div_intro",
    attrs: {
      "epub:type": "introduction"
    }
  }, [_c('div', {
    staticClass: "pre",
    attrs: {
      "id": "pre-002"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_1",
      "title": "1"
    }
  }, [_c('h1', {
    staticClass: "pre_tit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_vm._v("INTRODUCTION")])]), _c('h1', {
    staticClass: "pre_stit",
    attrs: {
      "epub:type": "subtitle"
    }
  }, [_c('span', [_vm._v("THE STATE "), _c('i', [_vm._v("of the")]), _c('br'), _vm._v("EVANGELICAL MIND:"), _c('br'), _vm._v("TALES "), _c('i', [_vm._v("of")]), _vm._v(" PROSPERITY "), _c('i', [_vm._v("and")]), _vm._v(" PERIL")])]), _c('h1', {
    staticClass: "pre_sstit",
    attrs: {
      "epub:type": "subtitle"
    }
  }, [_c('span', [_c('img', {
    staticClass: "imagelarge_intext",
    attrs: {
      "alt": "Illustration",
      "id": "fig-002_1",
      "src": "images/CH_dingbat_gray.jpg"
    }
  })])]), _c('p', {
    staticClass: "auteur"
  }, [_vm._v("TODD C. REAM, JERRY PATTENGALE,"), _c('br'), _c('i', [_vm._v("and")]), _vm._v(" CHRISTOPHER J. DEVERS")]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("N")]), _vm._v(" 1994, W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ILLIAM")]), _vm._v(" B. E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERDMANS")]), _vm._v(" published one of its most influential titles—Mark A. Noll’s "), _c('i', [_vm._v("The Scandal of the Evangelical Mind")]), _vm._v(". This “epistle from a wounded lover” reflects Noll’s desire to hold together two commitments others would often perceive at odds with one another: a love for both the life of the mind and a faith in Christ inspired by the love of fellow evangelicals."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-001",
      "id": "ap_ntb-001-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("In his “historical meditation in which sermonizing and the making of hypotheses vie with more ordinary exposition,” Noll’s aspiration was nothing short of inciting an intellectual renaissance."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-002",
      "id": "ap_ntb-002-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" The challenge was in the opening line of his first chapter: “The scandal of the evangelical mind is that there is not much of an evangelical mind.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-003",
      "id": "ap_ntb-003-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" Where then would scholars incited to an intellectual renaissance turn for inspiration?")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_2",
      "title": "2"
    }
  }, [_vm._v("Part of what offered that inspiration came in the pages that followed. Contrary to what was just noted and what Noll claimed to pursue, his own book not only laid bare how such a scandal had come to pass but also how evangelicalism, when properly understood, was not bereft of inspiration. For example, Noll turns to Jonathan Edwards, “a defender of the Great Awakening,”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-004",
      "id": "ap_ntb-004-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _vm._v(" to whom “there was no antithesis between heartfelt devotion and the most recondite labors of the mind.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-005",
      "id": "ap_ntb-005-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Evangelical scholars have often believed the bewildering array of challenges before them were unprecedented. With figures such as Edwards, however, they have not been alone. Noll was quick to point out that “Edwards lived through a period of rapidly changing conceptions of the world, God, and humanity.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-006",
      "id": "ap_ntb-006-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])]), _vm._v(" However, Noll was equally quick to point out that “the intellectual achievement of Jonathan Edwards was his refusal to admit that these assumptions were in fact the starting points of thought.” Instead of simply rejecting the intellectual currents of his age, Edwards’s work “dealt constantly with ideas at their foundations.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-007",
      "id": "ap_ntb-007-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("With Edwards in their lineage and Noll inciting them to commit prayerfully to the intellectual labor needed to deal with ideas at their foundations, evangelical scholars got to work. Admittedly, evangelical scholars such as Arthur Holmes had made similar pleas in the recent past."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-008",
      "id": "ap_ntb-008-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" But rising enrollments at many evangelical colleges and seminaries in the 1980s and 1990s, a healthy global economy, and rapidly warming relations between evangelicals and brethren from other Christian traditions (such as Catholicism and, in particular, its "), _c('i', [_vm._v("ressourcement")]), _vm._v(" movement) "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_3",
      "title": "3"
    }
  }, [_vm._v("who came bearing additional intellectual resources accented the timeliness of Noll’s challenge. A tangible expression of the intellectual renaissance Noll sought to incite came when Christianity Today launched "), _c('i', [_vm._v("Books & Culture")]), _vm._v(" just one year after the publication of "), _c('i', [_vm._v("Scandal.")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Moving ahead to 2015, the twentieth-anniversary edition of "), _c('i', [_vm._v("Books & Culture")]), _vm._v(" came with the question “What Scandal?” emblazoned across its cover. What then were scholars to make of the state of the evangelical mind when "), _c('i', [_vm._v("Books & Culture")]), _vm._v(" closed one year later? Was Christianity Today’s decision to do so the result of the challenges facing the wider publishing industry by a public prone to expect in the age of the digital platform that content was available apart from any financial commitment? Were other economic, political, or even theological forces at work? Regardless, if the launching of "), _c('i', [_vm._v("Books & Culture")]), _vm._v(" was a triumph for the state of the evangelical mind, what was its closure?")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Supported by the generosity of Indiana Wesleyan University president, David W. Wright, and provost, Stacy Hammons, scholars gathered at the Sagamore Institute in Indianapolis in September 2017 to ponder that question. (Considerable credit also goes to Jack Gardner and his colleagues at Jax Café, who graciously hosted planning discussions for this event.) The chapters in this volume, along with the essays found in the summer 2017 theme issue of "), _c('i', [_vm._v("Christian Scholar’s Review,")]), _vm._v(" are the outgrowth of those conversations. Before offering details concerning prosperity and peril for the evangelical mind, as well as of the chapters that follow, defining evangelicalism is in order.")]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-001"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("DEFINING EVANGELICALISM")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("In "), _c('i', [_vm._v("Deconstructing Evangelicalism: Conservative Protestantism in the Age of Billy Graham")]), _vm._v(", D. G. Hart opens on a personal yet telling note about struggles to define the term "), _c('i', [_vm._v("evangelicalism")]), _vm._v(". Hart, a Presbyterian, and a member of the Orthodox Presbyterian Church (OPC) at that, "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_4",
      "title": "4"
    }
  }, [_vm._v("questions whether being referenced as an evangelical was apt and, if so, desirable. He thus poses the question, “Why is it, then, that evangelicalism has become so elastic as to include believers whose beliefs and practices are at odds with the low-church revivalistic form of piety produced and distributed by numerous successful parachurch organizations?”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-009",
      "id": "ap_ntb-009-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])]), _vm._v(" He then goes on to argue that “born-again Protestants would be better off if they abandoned the category altogether . . . because it does not exist.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-010",
      "id": "ap_ntb-010-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("While Hart’s point concerning the elastic nature of evangelicalism is apt (especially when compared to his own OPC), it does not necessarily follow that evangelicalism does not exist. In the United States and in a number of other contexts around the world, evangelicals, however loosely configured, are a historically, sociologically, and theologically identifiable Christian tradition. That sense of tangible identification comes, as Hart argues, in parachurch organizations. As implicitly argued in the chapters in this book, tangible identification also comes in churches, colleges and universities, and seminaries that in their own ways contribute to the cultivation of the evangelical mind.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Even if Hart’s assertion is not entirely accurate, the concern he raises about the amorphous nature of evangelicalism still stands. Perhaps the best way to address that concern is through what is arguably the most widespread definition offered to date and known popularly as “the Bebbington quadrilateral,” framed by David Bebbington in "), _c('i', [_vm._v("Evangelicalism in Modern Britain: A History from the 1730s to the 1980s")]), _vm._v(":")]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre"
  }, [_vm._v("There are four qualities that have been the special marks of Evangelical religion: conversionism, the belief that lives need to be changed; activism, the expression of the gospel in effort; biblicism, a particular regard for "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_5",
      "title": "5"
    }
  }, [_vm._v("the Bible; and what may be termed crucicentrism, a stress on the sacrifice of Christ on the cross. Together they form a quadrilateral of priorities that is the basis of Evangelicalism."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-011",
      "id": "ap_ntb-011-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Bebbington’s quadrilateral has pliability. This was important for its traction among scholars striving to identify evangelicalism from a wide variety of disciplinary backgrounds. In particular, those marks bear a measure of theological specificity while also allowing for empirical confirmation of groups of believers as well as institutions they populate—such as churches, parachurch organizations, colleges and universities, and seminaries.")])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-002"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("A TALE OF PROSPERITY?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("As previously noted, the years following the publication of Noll’s "), _c('i', [_vm._v("Scandal ")]), _vm._v("were defined by relative prosperity. The rise of "), _c('i', [_vm._v("Books & Culture")]), _vm._v(" was one expression of that prosperity, but other important expressions are also available. The indication of those signs of prosperity had become so widespread that in 2007 the monograph series sponsored by Association for the Study of Higher Education and published by Jossey-Bass offered "), _c('i', [_vm._v("Christian Faith and Scholarship: An Exploration of Contemporary Developments")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-012",
      "id": "ap_ntb-012-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])]), _vm._v(" While that volume includes a record of work being done among Catholic scholars and a few mainline Protestant scholars, the bulk of its focus is on the work being done by evangelicals. Thirteen years following the publication of "), _c('i', [_vm._v("Scandal")]), _vm._v(", some of those details, further signs of prosperity, are worth noting.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("First, many evangelical scholars not only became involved at higher levels—and in some cases, even the highest of levels within the professional associations defining their disciplines—but also worked to launch "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_6",
      "title": "6"
    }
  }, [_vm._v("or strengthen professional associations represented by Christian scholars. Disciplines in the humanities such as English, history, and philosophy, and in the behavioral sciences such as psychology and related fields, probably saw the greatest gains in these areas. For example, Nicholas Wolterstorff, once a member of the philosophy department at Calvin College and then the Noah Porter Professor of Philosophical Theology at Yale University, was the American Philosophical Association Central Division president and an American Academy of Arts and Sciences fellow. However, he also served as president of the Society of Christian Philosophers, whose journal, "), _c('i', [_vm._v("Faith and Philosophy")]), _vm._v(", grew to be among the most highly regarded journals in the field.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("While Wolterstorff may rightfully be among the most prominent of Christian scholars, and philosophy may be one of the disciplines in which Christian scholars exerted some of the greatest influence, such gains were seen in other areas. For example, one exhibit found in "), _c('i', [_vm._v("Christian Faith and Scholarship")]), _vm._v(" lists over forty Christian professional associations in disciplines ranging from the humanities to the social sciences to the natural sciences."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-013",
      "id": "ap_ntb-013-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])]), _vm._v(" Some disciplines even have organizations representing subdisciplines such as neuroscience. Many of these organizations now also sponsor academic journals. For example, the Conference on Faith and History sponsors "), _c('i', [_vm._v("Fides et Historia")]), _vm._v(", the Society of Christian Psychology sponsors "), _c('i', [_vm._v("Christian Psychology")]), _vm._v(", and the Association of Christians in the Mathematical Sciences recently moved from sponsoring the "), _c('i', [_vm._v("Journal of the Association of Christians in the Mathematical Sciences")]), _vm._v(" to publishing its refereed conference proceedings.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("At the same time, the evangelical colleges and universities where many of these scholars served were seeing unprecedented growth. Part of this growth came through the establishment of programs initially "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_7",
      "title": "7"
    }
  }, [_vm._v("designed to meet the educational needs of working adults. Some components of those programs were then made available online once the technology was widely available. However, the infrastructures of these institutions designed to meet the educational expectations of “traditional-age” college students (eighteen to twenty-two years of age and residential) also grew at unprecedented rates.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("For example, between 1990 and 2004, the U.S. Department of Education data suggests that there was 12.8 percent growth for four-year public institutions, 28 percent growth for four-year independent institutions, and 70.6 percent growth for evangelical colleges and universities (memberships in the Council for Christian Colleges and Universities)."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-014",
      "id": "ap_ntb-014-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])]), _vm._v(" While the state of the evangelical mind in the United States is the primary focus of this volume, those numbers prove to be more dramatic when the circle of institutions is expanded to include the fact that seventy-nine new Protestant colleges or universities were started in Asia, Africa, and Oceania between 1980 and 2009."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-015",
      "id": "ap_ntb-015-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Beyond the associations and institutions many evangelical scholars populated, other institutions grew during this period of time in terms of both the quantity and quality of their efforts, institutions upon which evangelical scholars also came to depend when sharing their work. Of greatest importance may be publishing houses. Evangelical scholars began publishing books with university presses and various trade publishers with greater frequency during the 1990s and 2000s. However, publishers such as William B. Eerdmans, the previously noted publisher of "), _c('i', [_vm._v("Scandal")]), _vm._v(", Baker Academic, and IVP Academic became even more critical partners in this process. At the same time, new or revamped publishers such as Abilene Christian University Press, Baylor University "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_8",
      "title": "8"
    }
  }, [_vm._v("Press, Kregel Publications, and Wipf and Stock, to name only a few, joined those ranks in their own ways. As a result, evangelical scholars were not only generating more work but also had access to a wider network of publishing partners who were increasingly capable of sharing that work.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Finally, in ways comparable to the recognition evangelical scholars such as Nicholas Wolterstorff were receiving from various academic associations, the work of others was garnering prizes of considerable significance. Among the most noteworthy was when George M. Marsden’s "), _c('i', [_vm._v("Jonathan Edwards: A Life")]), _vm._v(" received the Bancroft Prize in 2004. “The Bancroft Prizes were established at Columbia University in 1948 with a bequest from Frederic Bancroft, the historian, author and librarian of the Department of State, to provide steady development of library resources, to support instruction and research in American history and diplomacy and to recognize exceptional books in the field.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-016",
      "id": "ap_ntb-016-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])]), _vm._v(" In relation to Marsden’s work, jurors for the prize noted, “Moving easily from the expansive realms of transatlantic thought to the narrow precincts of town and gown squabbles, Marsden captures both the man and his times in all their color and complexity.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-017",
      "id": "ap_ntb-017-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Two years later, the “wounded lover” who set out to incite an intellectual renaissance amongst evangelical scholars would be a National Humanities Medalist. The award Mark Noll received “honors individuals or groups whose work has deepened the nation’s understanding of the humanities and broadened our citizens’ engagement with history, literature, languages, philosophy, and other humanities subjects.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-018",
      "id": "ap_ntb-018-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])]), _vm._v(" Other individuals receiving the National Humanities Medal that year "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_9",
      "title": "9"
    }
  }, [_vm._v("include Nobel Prize winning economist James M. Buchanan and Nikolas Davatzes, founder of the History Channel, the A&E Network, and the Biography Channel. In relation to Noll’s contributions, the National Endowment for the Humanities noted, “As a historian, Noll has established himself as a leading scholar on the history of Christianity in the United States.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-019",
      "id": "ap_ntb-019-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-003"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("A TALE OF PERIL?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Shortly after Noll’s National Humanities Medal was minted, the state of the evangelical mind, albeit slowly but surely, began to change."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-020",
      "id": "ap_ntb-020-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])]), _vm._v(" In 2007, cracks were beginning to form in the global economy, and by 2008 the worst economic downturn since the Great Depression was underway. For example, institutions such as many evangelical colleges, universities, and seminaries were fortunately, at that time, not heavily endowed. As a result, their tuition-driven status served them well in the short run. Individuals who lost jobs sought to enhance their expertise or change professions and returned to school.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("As has been historically proven, however, being heavily endowed, even if painful in the late 2000s, yields greater financial security than being heavily dependent upon tuition revenue. As the stock market rose, so did college endowments. However, the lingering effects of the recession eventually came calling for heavily tuition-dependent institutions. Part of the reason for this mounting challenge came at the nexus of concerns over personal debt and the seemingly ever-increasing cost of tuition at private institutions. In the early 2010s, facing the possibility of enrollment downturns, many Christian colleges and universities "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_10",
      "title": "10"
    }
  }, [_vm._v("sought to maximize their discount rates or the level of financial aid they could offer in relation to their costs for tuition—and in some cases, room and board as well. An arms race in financial aid thus ensued as many institutions, afraid of posting declining enrollments, allowed their discount rates to rise to unsustainable levels. At the same time, some schools had no choice but to face the reality of “right-sizing,” or laying off staff, administrators, and faculty members."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-021",
      "id": "ap_ntb-021-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("If these financial challenges were not enough to at least initiate a more cautious spirit among institutions called to cultivate the evangelical mind, a confusing political climate unleashed even more anxiety. While never simple, the landscape shared by evangelicals and American political life in the months leading up to the 2016 presidential election proved even more complicated than in recent years. Racing toward the finish line were two candidates with the lowest favorability ratings in history—Hillary Rodham Clinton and Donald J. Trump. According to a Gallup poll released on election day, “Trump’s 61% unfavorable score is worst in presidential polling history,” while “Clinton’s 52% unfavorable score is second-worst.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-022",
      "id": "ap_ntb-022-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])]), _vm._v(" Early the next day, predictions that the candidate with the second-worst unfavorable score would win proved to be wrong as Trump emerged as the forty-fifth president of the United States.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("White evangelicals historically tend to vote in larger numbers for Republican presidential candidates than Democrats. Despite garnering "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_11",
      "title": "11"
    }
  }, [_vm._v("the worst unfavorable score in history, that voting trend, despite some predictions, only continued in relation to Trump. The Pew Research Center noted, “White, born-again/evangelical Christian[s] voted for Trump to the tune of 81% in 2016. In comparison, 78% of white evangelicals voted for Mitt Romney in 2012, 74% voted for John McCain in 2008, and 78% voted for George W. Bush in 2004.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-023",
      "id": "ap_ntb-023-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])]), _vm._v(" In "), _c('i', [_vm._v("The Evangelicals: The Struggle to Shape America")]), _vm._v(", Pulitzer Prize–winning author Frances FitzGerald notes white evangelical leaders decided that “Trump wasn’t so bad: At least he wasn’t Hilary Clinton.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-024",
      "id": "ap_ntb-024-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("If challenges posted by the wider economic and political climates were not enough, evangelicals also found themselves dealing with an uncharted set of theological questions that revolved in particular around questions of same-sex attraction. On June 26, 2015, the United States Supreme Court issued its opinion in "), _c('i', [_vm._v("Obergefell et al. v. Hodges, Director, Ohio Department of Health, et al.")]), _vm._v(" Writing for the majority, Justice Anthony Kennedy offered men and women seeking to marry members of the same sex hope “not to be condemned to live in loneliness, excluded from one of civilization’s oldest institutions. They ask for equal dignity in the eyes of the law. The Constitution grants them that right.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-025",
      "id": "ap_ntb-025-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The Patient Protection and Affordable Care Act signed into law by President Barack Obama on March 23, 2010, raised considerable "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_12",
      "title": "12"
    }
  }, [_vm._v("questions for religious institutions in relation to the latitude they would possess concerning how they provided health care for their employees. Such questions already made their way to the Supreme Court via cases such as "), _c('i', [_vm._v("Burwell, Secretary of Health and Human Services, et al. v. Hobby Lobby Stores, Inc.")]), _vm._v(", a case decided no more than one year before Obergefell. Beyond the decision itself, however, Obergefell exposed fault lines among evangelicals that existed prior to the decision but had generally gone unrecognized.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("In"), _c('i', [_vm._v(" Still Evangelical? Ten Insiders Reconsider Political, Social, and Theological Meaning")]), _vm._v(", Mark Labberton, president of Fuller Theological Seminary, writes, “As the East and West Coasts of the United States have led the way in the growing affirmation of LGBT people and lifestyles, evangelicals in these regions have quietly done likewise.” In particular, Labberton offers, “Perhaps even more noteworthy is the generational divide over the acceptance of LGBT relationships, with affirmation from 47 percent of white evangelicals under the age of 30, despite their otherwise more traditional views.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-026",
      "id": "ap_ntb-026-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Cumulatively, these financial, political, and theological realities, among others, called into question the confidence of evangelicals and, in the case of this particular work, of evangelicals called to cultivate the mind. Churches, parachurch organizations, colleges and universities, and seminaries were now often more consumed with navigating these realities than they were with advancing an agenda of their own creation. For example, research and the fruits it yielded came to seem like a luxury to college and university administrators trying to balance budgets. Regardless of the quality of their work, faculty committed to those tasks, especially if those tasks came with lighter teaching loads and thus lower tuition generation, were vulnerable to layoffs. How then "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_13",
      "title": "13"
    }
  }, [_vm._v("would these leaders navigate such a future for their institutions? After years of prosperity, was the state of the evangelical mind now once again a story of peril?")])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-004"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("CHARTING A WAY FORWARD")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Amid these realities, the contributors to this volume collectively seek to assess the state of the evangelical mind, identify its unique contributions, and chart a way forward. As already suggested, doing so primarily focuses on four sets of institutions historically charged with the cultivation of the evangelical mind: churches, parachurch organizations, colleges and universities, and seminaries. While the efforts of individuals are critical to the cultivation of the evangelical mind, sustained change often comes through contributions they make in various ways through one or more of these types of institutions.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("While rightfully quick to note institutions “make possible, and perpetuate in the deepest and most lasting ways, the twin distortions of idolatry and injustice,” in "), _c('i', [_vm._v("Playing God: Redeeming the Gift of Power")]), _vm._v(" Andy Crouch also boldly claims that “institutions make image bearing possible.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-027",
      "id": "ap_ntb-027-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])]), _vm._v(" For these reasons, the contributors to this volume, both individuals of considerable influence in the lives of the institutions about which they write, focus on how churches, parachurch organizations, colleges and universities, and seminaries contribute to the life of the evangelical mind.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("We know of no better way to open such a conversation than to turn to Mark Noll himself and ask him to offer a more detailed set of reflections on the recent past—the past since the publication of "), _c('i', [_vm._v("Scandal")]), _vm._v(". Respectively, Jo Anne Lyon, David C. Mahan and C. Donald Smedley, Timothy Larson, and Lauren F. Winner focus their energies on churches, "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_14",
      "title": "14"
    }
  }, [_vm._v("parachurch organizations, colleges and universities, and seminaries. To conclude, James K. A. Smith details prospects for the future, while Mark Galli seeks to clarify what is unique about evangelicalism and the evangelical mind.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Despite their expertise, none of these contributors claim to offer all of the answers. However, what they do offer is a context in which conversations concerning the present state and the future of the evangelical mind can be processed. What then is needed is for all who care about the cultivation of the evangelical mind to process what they offer and prayerfully consider what unique contributions they are called to make. If done in a context defined by our own capacities, considering the future likely brings fear. However, if done in a context defined by God’s grace, considering the future comes with hope—hope granted by the life, death, and resurrection of Christ and the knowledge of what is to come. What is left to do is prayerfully consider and then act on the details.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('i', [_vm._v("Advent 2017")])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Videos of the conference sessions on which this book is based, as well as of respondents’ comments, can be viewed at "), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "https://www.ivpress.com/tsem-videos",
      "target": "_blank"
    }
  }, [_vm._v("ivpress.com/tsem-videos")]), _vm._v(". These videos also include a special interview with Abson Joseph and Donald Cassell on evangelicals in the international context, hosted by Jay Hein.")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30defbe2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pre3.vue
// module id = 69
// module chunks = 0